import { format, UTCDate } from '@/utils/dates';
import { Currency } from '@seapoint/server/enums';
import { Button } from '../../../../design-system/button/button';
import { Inline } from '../../../../design-system/inline/inline';
import { Stack } from '../../../../design-system/stack/stack';
import { PayrollView } from '../../../../types/entity-types';
import { getAmountWithCurrency } from '../../../../utils/get-amount-with-currency';
import { PayrollSummaryCard } from '../payroll-approval-step/payroll-summary-card';
import { PayrollSummaryTable } from '../payroll-approval-step/payroll-summary-table/payroll-summary-table';

type CompletedPayrollSummaryProps = {
  payroll?: PayrollView | null;
  currency?: Currency;
  onContinue: () => void;
};

export const CompletedPayrollSummary = ({ payroll, currency, onContinue }: CompletedPayrollSummaryProps) => {
  if (!currency || !payroll) {
    return null;
  }
  const totalNetPay = payroll.records.reduce((acc, record) => acc + record.netPay, 0);
  const formattedPaidDate = format(new UTCDate(payroll.period), 'MMM d yyyy');

  return (
    <Stack space={4} className="mt-10 w-full" align="end">
      <Inline className="w-full">
        <div className="flex-1">
          <PayrollSummaryCard
            payrollName={payroll.name}
            country={payroll.country}
            period={payroll.period}
            company={payroll.company.legalEntity.name}
            status={payroll.status}
          />
        </div>
        <Stack className="rounded-lg bg-white px-5 py-4" space={2}>
          <p className="text-left text-sm text-muted-foreground">Pay Date</p>
          <p className="text-base">{formattedPaidDate}</p>
        </Stack>
        <Stack className="rounded-lg bg-white px-5 py-4" align="end" space={2}>
          <p className="text-sm text-muted-foreground">Total net pay</p>
          <p className="text-lg font-semibold">
            {getAmountWithCurrency({
              amount: totalNetPay,
              currency: payroll.currency,
              isAccountBalance: true,
            })}
          </p>
        </Stack>
      </Inline>
      <PayrollSummaryTable records={payroll.records} />
      <Button variant="default" onClick={onContinue}>
        Copy as new payroll
      </Button>
    </Stack>
  );
};
